export const getErrorMessage = (error: any) => {
  const data = error.response?.data;
  return data?.message || data || error.message || 'Please try again later';
};
